import { useMemo } from 'react'

export interface Resolution {
  height: number
  width: number
}

// Returns the current viewport dimensions for component sizing.
// Font scaling is handled by CSS calc(100vh / 108) in index.css.
// When ?res= override is active, JS sets the root font-size directly.
export const useResolution = (): Resolution => {
  return useMemo(() => {
    const height = window.innerHeight
    const width = window.innerWidth
    return { height, width }
  }, [])
}
